import { allThemes } from "@/modules/theme/allThemes.ts";
import { mustGetOwn } from "@warrenio/utils/collections/getOwnProperty";

export function getTheme(id: string) {
    return mustGetOwn(allThemes, id, "all themes");
}
